import React, { useContext } from "react";
import AutocompleteTextInput from "components/FormElements/AutocompleteTextInput";
import Label from "components/FormElements/Label";
import { ContentContext } from "context/Content";
import { useSelector } from "react-redux";

export default function SstsField(props) {
    const { state } = useContext(ContentContext);
    const sstsValues = useSelector((state) => state.contentFlow.ssts);

    if (state.loading) {
        return (
            <div>
                <Label>SSTS</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <AutocompleteTextInput
            label="SSTS"
            name="ssts_path"
            id="ssts_path"
            disabled={
                state.loading ||
                state.performingStateChange ||
                !state.isUserEditable
            }
            setValue={(item, field, setFieldValue) => {
                setFieldValue("ssts_path", item.label);
                setFieldValue("ssts_id", item.value);
            }}
            onRequestSearch={async (term) => {
                if (!sstsValues.data || !sstsValues.data.length) {
                    return Promise.resolve(() => {
                        return [{ label: "No SSTS values", value: 0 }];
                    });
                }

                return sstsValues.data
                    .filter((item) => {
                        return item.path
                            .toLowerCase()
                            .includes(term.toLowerCase());
                    })
                    .map((item) => {
                        return {
                            label: item.path,
                            value: item.id,
                        };
                    });
            }}
        />
    );
}
